import type { InputHTMLAttributes } from 'react';
import { nationalToE164, parseE164Phone } from '../../lib/intlPhone';
import { IntlPhoneField } from './IntlPhoneField';

type SgPhoneFieldProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'value' | 'onChange' | 'type' | 'inputMode'
> & {
  value: string;
  onChange: (e164OrEmpty: string) => void;
  inputClassName?: string;
};

/** Keep only the local 8-digit SG subscriber number (after +65). */
export function sgPhoneLocalDigits(raw: string): string {
  const { nationalDigits } = parseE164Phone(raw, 'SG');
  return nationalDigits.slice(0, 8);
}

export function sgPhoneToE164(raw: string): string {
  const local = sgPhoneLocalDigits(raw);
  return local ? nationalToE164('SG', local) : '';
}

/** Singapore default; supports other countries via the shared intl phone field. */
export function SgPhoneField(props: SgPhoneFieldProps) {
  return <IntlPhoneField defaultCountry="SG" {...props} />;
}
